/**
 * Mutual exclusion lock
 */
class Mutex {
    mutex = Promise.resolve();
    /**
     * Run `fn` only if the lock is available, if it's not wait for it.
     * @param fn the function that requires the lock to run.
     * @returns a promise with the result of the requested operation.
     */
    async run(fn) {
        return new Promise((resolve, reject) => {
            this.mutex = this.mutex.then(async () => {
                try {
                    resolve(await fn());
                }
                catch (err) {
                    reject(err);
                }
            });
        });
    }
}
export default Mutex;
//# sourceMappingURL=mutex.js.map